import type { GetGenerationImagesSettingsApiResponse } from '~services/api/generation';

const apiBase = process.env.PUBLIC_API ?? 'https://api.ifriend.ai';

const DAY_HALF = 60 * 60 * 12;

export const getGenerationImagesSettings = async (params?: RequestInit) => {
	const response = await fetch(`${apiBase}/ai/generation/images/settings`, {
		...params,
		next: {
			revalidate: DAY_HALF,
			...params?.next,
			tags: ['generation-images-settings'],
		},
	});

	if (!response.ok) {
		throw new Error(`Error fetching images settings`);
	}

	const data =
		(await response.json()) as GetGenerationImagesSettingsApiResponse;

	return prepareGenerationImagesSettingsData(data);
};

export const prepareGenerationImagesSettingsData = (
	data: GetGenerationImagesSettingsApiResponse
): GetGenerationImagesSettingsApiResponse => ({
	...data,
	actions: data.actions || [],
	poses: data.poses || [],
});
